// extracted by mini-css-extract-plugin
module.exports = {"main":"Annotators_main__1S3bt","buttonsContainer":"Annotators_buttonsContainer__3f_bN"};